import {getCurrentYear} from '../../utils/commons'
import GardenBestPicksLogo from './logo'
import {gardenBestPicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'gardenbestpicks' as const,
  domainType: 'picks' as const,
  siteName: 'Garden Best Picks',
  logo: <GardenBestPicksLogo className="size-14 shrink-0 tablet:size-10" />,
  favicon: '/favicons/gardenbestpicks.png',
  styles: gardenBestPicksStylesUS,
}

const localeConfigs = {
  us: {
    measurementId: 'G-C09VXSWEB6',
    camelCaseUrl: 'GardenBestPicks.com',
    title: (_category: string, count: string) =>
      `Top ${count} Gardening Tools & Products ${getCurrentYear()} in the US | GardenBestPicks.com – Expert Reviews & Guides`,
    description: (_category?: string, _count?: string) =>
      `At GardenBestPicks.com, we review and compare the best gardening tools, gear, and essentials for ${getCurrentYear()}. Discover expert insights to help your garden thrive all year long.`,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
